// Chaves das consultas (TanStack Query). Tudo que depende do usuário logado fica
// sob ["me", ...] e é descartado quando a sessão muda.

export const qk = {
  categories: ['categories'] as const,
  settings: ['settings'] as const,
  platformStats: ['platform-stats'] as const,
  /** Configuração pública do Supabase Auth (provedores de acesso ligados). */
  authSettings: ['auth-settings'] as const,

  proposals: {
    all: ['proposals'] as const,
    list: ['proposals', 'list'] as const,
    detail: (slug: string) => ['proposals', 'detail', slug] as const,
    similar: (title: string) => ['proposals', 'similar', title] as const,
  },

  comments: (proposalId: string) => ['comments', proposalId] as const,
  suggestions: (proposalId: string) => ['suggestions', proposalId] as const,
  moderationLog: ['moderation-log'] as const,
  profile: (username: string) => ['profile', username] as const,

  me: {
    all: ['me'] as const,
    account: ['me', 'account'] as const,
    votes: ['me', 'votes'] as const,
    commentEndorsements: (proposalId: string) => ['me', 'comment-endorsements', proposalId] as const,
    suggestionEndorsements: (proposalId: string) => ['me', 'suggestion-endorsements', proposalId] as const,
    reports: ['me', 'reports'] as const,
    proposals: ['me', 'proposals'] as const,
    moderation: ['me', 'moderation'] as const,
  },

  admin: {
    all: ['admin'] as const,
    dashboard: ['admin', 'dashboard'] as const,
    proposals: (status: string) => ['admin', 'proposals', status] as const,
    proposal: (id: string) => ['admin', 'proposal', id] as const,
    reports: (status: string) => ['admin', 'reports', status] as const,
    actions: ['admin', 'actions'] as const,
    appeals: (status: string) => ['admin', 'appeals', status] as const,
    users: (search: string, page: number) => ['admin', 'users', search, page] as const,
    audit: (filters: string) => ['admin', 'audit', filters] as const,
  },
}
